import { auth, firestore } from '../firebaseConfig';
import { createUserWithEmailAndPassword, signInWithEmailAndPassword } from "firebase/auth";
import { doc, setDoc, updateDoc } from "firebase/firestore";
import { getAuth, sendPasswordResetEmail as firebaseSendPasswordResetEmail } from "firebase/auth";

// Function to register a user and store additional data in Firestore
export const registerUser = async (email, password, name) => {
  try {
    // Create user with email and password
    const userCredential = await createUserWithEmailAndPassword(auth, email, password);
    const user = userCredential.user;

    // Create a user document in Firestore with additional information
    await setDoc(doc(firestore, "users", user.uid), {
      name: name,
      isPaidUserFlag: false,  // Default to false (user is not a paid subscriber)
      isLoggedInFlag: true,   // Set isLoggedInFlag to true on registration
      customer_id: "",       // Initially empty, will be populated later
      subscription_id: "",   // Initially empty, will be populated later
      planId: "",            // Initially empty, will be populated later (if applicable)
      createdAt: new Date(), // Track the creation date of the user
    });

    return user;
  } catch (error) {
    console.error("Error registering user: ", error);
    throw error;
  }
};

// Function to log in a user and update the isLoggedInFlag in Firestore
export const loginUser = async (email, password) => {
  try {
    const userCredential = await signInWithEmailAndPassword(auth, email, password);
    const user = userCredential.user;

    // Update the user's Firestore document to set isLoggedInFlag to true
    const userDocRef = doc(firestore, "users", user.uid);
    await updateDoc(userDocRef, { isLoggedInFlag: true });

    return user;
  } catch (error) {
    console.error("Error logging in user: ", error);
    throw new Error(error.message);
  }
};


// Custom Send Password Reset Email
export const customSendPasswordResetEmail = async (email) => {
  const auth = getAuth();
  try {
    // Use the Firebase method to send the reset email
    await firebaseSendPasswordResetEmail(auth, email);
  } catch (error) {
    throw error;
  }
};